import {
	ADDITIONAL_DRIVER_MOTORING_CONVICTIONS_ERRORS,
	MOTORING_CONVICTIONS_ERRORS,
} from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import * as Yup from 'yup';

export const getMotoringConvictionsSchema = (isAdditionalDriver: boolean) => {
	const errorMessageObject = isAdditionalDriver
		? ADDITIONAL_DRIVER_MOTORING_CONVICTIONS_ERRORS
		: MOTORING_CONVICTIONS_ERRORS;

	return Yup.object().shape({
		dateOfConviction: Yup.object().shape({
			day: Yup.string().required(errorMessageObject.convictionDate),
			month: Yup.string().required(errorMessageObject.convictionDate),
			year: Yup.string().required(errorMessageObject.convictionDate),
		}),
		offenceCode: Yup.string().required(errorMessageObject.offenceCode),
		wasDisqualified: Yup.string().required(errorMessageObject.wasDisqualified),
		banStartDate: Yup.mixed().when('wasDisqualified', {
			is: 'yes',
			then: () =>
				Yup.object().shape({
					day: Yup.string().required(errorMessageObject.banStartDate),
					month: Yup.string().required(errorMessageObject.banStartDate),
					year: Yup.string().required(errorMessageObject.banStartDate),
				}),
			otherwise: (schema) => schema.notRequired(),
		}),
		banEndDate: Yup.mixed().when('wasDisqualified', {
			is: 'yes',
			then: () =>
				Yup.object().shape({
					day: Yup.string().required(errorMessageObject.banEndDate),
					month: Yup.string().required(errorMessageObject.banEndDate),
					year: Yup.string().required(errorMessageObject.banEndDate),
				}),
			otherwise: (schema) => schema.notRequired(),
		}),
		numberOfPoints: Yup.string().required(errorMessageObject.numberOfPoints),
		fineAmount: Yup.number().required(errorMessageObject.fineAmount),
		isPending: Yup.string().required(errorMessageObject.isPending),
	});
};
